import type { ReactNode } from 'react';

export const symbol_perm_scan_wifi: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M438-162 47-553q-9-9.08-13.5-20.43T29-596.14q0-12.86 5.5-24.76Q40-632.79 51-642q91-76 200.5-117T480-800q119 0 228.5 41T909-642q11 9.12 16.5 20.9t5.5 24.7q0 11.4-4.5 22.83Q922-562.14 913-553L522-162q-9 9-20 13t-22 4q-11 0-22-4t-20-13Zm42-40 392-392q-87-68-184.5-107T480-740q-110 0-207.5 39T88-594l392 392Zm-30-173q0 12.75 8.68 21.37 8.67 8.63 21.5 8.63 12.82 0 21.32-8.63 8.5-8.62 8.5-21.37v-160q0-12.75-8.68-21.38-8.67-8.62-21.5-8.62-12.82 0-21.32 8.62-8.5 8.63-8.5 21.38v160Zm51-249q9-9 9-21t-9-21q-9-9-21-9t-21 9q-9 9-9 21t9 21q9 9 21 9t21-9Zm-21 422Z"
		/>
	</svg>
);
